import React, { useContext } from 'react';
import { useQuery } from '@apollo/client';
import {
  Grid, Segment, Header, Card, Loader,
} from 'semantic-ui-react';
import ProjectCard from './ProjectCard';
import ProjectFilters from './ProjectFilters';
import { SEARCH_PROJECTS } from '../../queries/project';
import DataContext from '../../contexts/DataContext';

const FILTERS = {
  status: ['Active', 'Draft', 'Completed'],
  myProjectsOnly: false,
};

const SearchProjects = ({ query }) => {
  const { user } = useContext(DataContext);
  const { data, loading } = useQuery(SEARCH_PROJECTS, {
    fetchPolicy: 'network-only',
    variables: { query },
  });
  if (loading) return <Loader active size="big" />;

  const renderProjects = () => (
    <div>
      {data.searchProjects.total === 0 ? (
        <Grid container centered>
          <Segment>
            <div className="not-found">
              <Header as="h2">No Projects Found</Header>
            </div>
          </Segment>
        </Grid>
      ) : (
        <div className="project-list">
          <Card.Group itemsPerRow={2} stackable>
            {data.searchProjects.items.map(
              (i) => (
                <ProjectCard
                  key={i.item.id}
                  user={user}
                  project={i.item}
                  searchResult={{
                    ...i,
                    query,
                  }}
                />
              ),
            )}
          </Card.Group>
        </div>
      )}
    </div>
  );

  return (
    <Grid.Row>
      <Grid.Column width={4}>
        <ProjectFilters
          filters={FILTERS}
          updateFilter={() => {}}
        />
      </Grid.Column>
      <Grid.Column width={12}>
        {renderProjects()}
      </Grid.Column>
    </Grid.Row>
  );
};

export default SearchProjects;
